import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { Button, Dialog, DialogContent, makeStyles } from '@material-ui/core'
import { DateRangePicker } from 'materialui-daterange-picker'
import MyCloseIcon from '../../../../../assets/icons/MyCloseIcon'
import CalendarIcon from '../../../../../assets/icons/calendarIcon'
import { parseDate } from '../../../../../utils/helpers/dateHelpers/parseDate'
import dateRangeFieldStyles from './dateRangeField.styles'

const DateRangeField = (props) => {
  const { startDate, endDate, setFieldValue } = props
  const [open, setOpen] = useState(false)
  const useStyles = makeStyles(dateRangeFieldStyles)
  const classes = useStyles()

  const toggle = () => setOpen(!open)

  const handleDateRangePicker = (range) => {
    setFieldValue('startDate', range.startDate)
    setFieldValue('endDate', range.endDate)
    setOpen(false)
  }

  const formatDateLabel = () => {
    if (!startDate || !endDate) {
      return 'Set Dates'
    }
    return `${parseDate(startDate)} - ${parseDate(endDate)}`
  }

  return (
    <>
      <div className={classes.container}>
        <Button
          variant='outlined'
          onClick={toggle}
          startIcon={<CalendarIcon className={classes.calendarIcon} />}
          className={classes.button}
        >
          {formatDateLabel()}
        </Button>
      </div>

      <Dialog open={open} onClose={toggle} maxWidth={false} classes={{ paper: classes.dialog }}>
        <MyCloseIcon onClick={toggle} className={classes.closeIcon} />
        <DialogContent classes={{ root: classes.dialogContentRoot }}>
          <DateRangePicker
            open={true}
            toggle={() => {}}
            onChange={handleDateRangePicker}
            initialDateRange={{
              startDate: startDate || new Date(),
              endDate: endDate || new Date(),
            }}
            wrapperClassName={classes.dateRangePickerRoot}
            definedRanges={[]}
          />
        </DialogContent>
      </Dialog>
    </>
  )
}

DateRangeField.propTypes = {
  startDate: PropTypes.instanceOf(Date),
  endDate: PropTypes.instanceOf(Date),
  setFieldValue: PropTypes.func.isRequired,
}

export default DateRangeField
